import ModalBasic from "../../components/infrastructure/Modals/ModalBasic";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import { FaLink } from "react-icons/fa6";

const VideoPreview = ({
    previewModalOpen,
    setPreviewModalOpen,
    previewVideos = [],
}) => {
    return (
        <ModalBasic
            modalOpen={previewModalOpen}
            setModalOpen={setPreviewModalOpen}
            title="Video Preview"
            max_width="max-w-5xl"
        >
            <div className="relative overflow-y-auto">
                {previewVideos?.length > 0 ? (
                    <>
                        {previewVideos.map((video, index) => (
                            <div
                                key={index}
                                className="relative flex justify-center items-center p-4"
                            >
                                <PrimaryButton
                                    className="absolute right-6 bottom-6 z-10"
                                    onClick={() => {
                                        const fileUrl = `${process.env.REACT_APP_S3_URL}${video}`;
                                        window.open(fileUrl, "_blank");
                                    }}
                                >
                                    <FaLink size={16} />
                                </PrimaryButton>

                                <video
                                    controls
                                    className="w-full rounded-lg border"
                                    style={{ maxHeight: "75vh" }}
                                >
                                    <source
                                        src={`${process.env.REACT_APP_S3_URL}${video}`}
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        ))}
                    </>
                ) : (
                    <div className="flex items-center justify-center h-[300px] text-gray-500">
                        No Preview Available
                    </div>
                )}
            </div>
        </ModalBasic>
    );
};

export default VideoPreview;